<template>
    <CardPage :section="4" :page="12" nextLabel="Finish" :nextFunction="finish" :audio="true">
        <p>
            You’ve earned another sticker for completing this session!
        </p>
        <ResponsiveImage :src="sticker.image" :alt="sticker.text"></ResponsiveImage>
    </CardPage>
</template>

<script>
import { get } from 'vuex-pathify';

export default {
    computed: {
        sticker: get('section4/sticker')
    },
    methods: {
        finish() {
            this.$store.set('section4/sticker@earned', true);
        }
    }
};
</script>
